module.exports = __webpack_public_path__ + "media/images/common/menu_icon-3cb6f4282b104a9aa8ea941d8c42f4bf.png";